module.exports = __webpack_public_path__ + "02_short_yellow.696fe646.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/02_short_yellow.png
// module id = N05u
// module chunks = 0